export const JWT_NS = 'enhi';
